import { render, staticRenderFns } from "./TreasuryTransactionForm.vue?vue&type=template&id=aaf373a0&"
import script from "./TreasuryTransactionForm.vue?vue&type=script&lang=js&"
export * from "./TreasuryTransactionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports